import { render } from "./tab-ticket.vue?vue&type=template&id=6d8911b6&scoped=true&ts=true"
import script from "./tab-ticket.vue?vue&type=script&lang=ts"
export * from "./tab-ticket.vue?vue&type=script&lang=ts"

import "./tab-ticket.vue?vue&type=style&index=0&id=6d8911b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8911b6"]])

export default __exports__